import { Flex, SkeletonBox, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

const complianceSettingsFormFieldsSkeletons = [
  { height: 78, id: 'late-payment-penalty-rate' },
  { height: 68, id: 'early-payment-discount' },
  { height: 72, id: 'legal-guarantee-of-conformity' },
  { height: 38, id: 'accredited-association' },
  { height: 38, id: 'vat-on-debits' },
]
export const ComplianceSettingsFormFieldsSkeletons = (): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S24}>
    {complianceSettingsFormFieldsSkeletons.map(({ height, id }) => (
      <SkeletonBox fullWidth height={height} key={id} />
    ))}
  </Flex>
)
